module.exports = __webpack_public_path__ + "static/media/S600.e0b28ef5.png";